import React from "react";
import './InputCalendario.scss'
import {Calendar} from 'primereact/calendar';

const InputCalendario = ({
                             titulo,
                             value,
                             onChange,
                             obligatorio = true,
                             id,
                             view,
                             onltyTime,
                             dateFormat = "dd/mm/yy",
                             placeholder,
                             disabled = false,
                             readOnlyInput = false
                         }) => {
    return (
        <div className="InputCalendario">
            <div className="tituloContenedor">
                {
                    obligatorio ?
                        <>
                            <div className="obligatorio">*</div>
                        </> : null
                }
                <div className="titulo">{titulo}</div>
            </div>
            <Calendar readOnlyInput={readOnlyInput} disabled={disabled} id={id} placeholder={placeholder}
                      className="calendario" hourFormat="24" timeOnly={onltyTime} value={value} onChange={onChange}
                      dateFormat={dateFormat} showIcon
                      pt={{
                          dropdownButton: {
                              root: {className: 'colorNaranja'}
                          }
                      }}
            />
        </div>
    )
}
export default InputCalendario